import { useMutation } from 'react-query';
import Patients from 'src/services/Patients';

export const useCreateGfeRequest = () =>
  useMutation(({ patientId, requestType }: { patientId: number | string; requestType: number }) =>
    Patients.createGfeRequest(patientId as string, requestType)
  );
